interface FinalCTAProps {
  onRequestAccess: () => void
  onLogin: () => void
}

export default function FinalCTA({ onRequestAccess, onLogin }: FinalCTAProps) {
  return (
    <section id="contact" className="mf-section mf-final-cta">
      <div className="mf-container mf-reveal">
        <h2>Ready to Simplify Your Dairy Operations?</h2>
        <p>
          Start managing your dairy subscriptions, customers, deliveries and orders with MilkFlow.
        </p>
        <div className="mf-hero-ctas">
          <button className="mf-btn-primary-lg" onClick={onRequestAccess}>
            Get Started
          </button>
          <button className="mf-btn-secondary-lg" onClick={onLogin}>
            Login
          </button>
        </div>
      </div>
    </section>
  )
}
